<div class="component-page-header"></div>

<ng-container *ngIf="userObservable | async; let user">
  <mat-card class="mt-4">

    <app-article-header>
      <mat-card-title>
        <span>Profile</span>
      </mat-card-title>
    </app-article-header>

    <app-article-content class="py-2">
      <div class="main-title">
        <h1>About Me</h1>
        <div class="divider">
          <div class="zigzag large clearfix "  data-svg-drawing="yes" >
            <svg xml:space="preserve" viewBox="0 0 69.172 14.975" width="37" height="28" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1">
            <path d="M1.357,12.26 10.807,2.81 20.328,12.332
              29.781,2.879 39.223,12.321 48.754,2.79 58.286,12.321 67.815,2.793 "  style="stroke-dasharray: 93.9851, 93.9851; stroke-dashoffset: 0;"/>
          </svg>
          </div>
        </div>
      </div>

      <div class="px-3 py-4">
        <h2 class="d-inline-block">{{ user.name }}</h2>
        <app-user-update-profile-button [user]="user">
          <button mat-icon-button class="float-right">
            <mat-icon class="color-gray">edit</mat-icon>
          </button>
        </app-user-update-profile-button>
        <h5>{{ user.email }}</h5>
      </div>
    </app-article-content>

  </mat-card>
</ng-container>





// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/user-profile/user-profile.component.html